export default __webpack_public_path__ + "static/media/notfound.b0232c0e.gif";